import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileMenu from "../MobileMenu/MobileMenu";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";
import Logo from "../../images/TLM Logo.png";
import pr1 from "../../images/resource/post-thumb-1.jpg";
import pr2 from "../../images/resource/post-thumb-2.jpg";
import pr3 from "../../images/resource/post-thumb-3.jpg";

const Header = (props) => {
  const [searchActive, setSearchState] = useState(false);
  const [cartActive, setCartState] = useState(false);
  const location = useLocation();

  const SubmitHandler = (e) => {
    e.preventDefault();
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const isActive = (path) => {
    return location.pathname === path ? { fontWeight: "bold" } : {};
  };

  return (
    <header className="main-header">
      {/* Header Upper */}
      <div className="header-upper">
        <div className="auto-container">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <div className="logo-box">
              <div className="logo">
                <Link onClick={ClickHandler} to="/">
                  <img src={Logo} alt="" title="" width={80} />
                </Link>
              </div>
            </div>

            <div className="nav-outer">
              {/* Main Menu */}
              <nav className="main-menu navbar-expand-md">
                <div className="navbar-header">
                  {/* Toggle Button */}
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>

                <div
                  className="navbar-collapse collapse clearfix"
                  id="navbarSupportedContent"
                >
                  <ul className="navigation clearfix">
                    <li>
                      <Link
                        to="/"
                        style={isActive("/")}
                      >
                        Home
                      </Link>
                    </li>
                    <li className="dropdown">
                      <Link onClick={ClickHandler} to="/about" style={isActive("/about")}>
                        About
                      </Link>
                      <ul>
                        <li>
                          <Link onClick={ClickHandler} to="/about">
                            About us
                          </Link>
                        </li>
                        {/* <li>
                          <Link onClick={ClickHandler} to="/faq">
                            Faq's
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/price">
                            Price
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/schedule">
                            Schedule
                          </Link>
                        </li> */}
                        <li>
                          <Link onClick={ClickHandler} to="/gallery">
                            Gallery
                          </Link>
                        </li>
                        {/* <li>
                          <Link onClick={ClickHandler} to="/testimonial">
                            Testimonial
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/coming-soon">
                            Coming Soon
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/terms">
                            Terms & Condition
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/privacy">
                            Privacy & Policy
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/zentara" style={isActive("/zentara")}>
                        Zentara
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to="/event" style={isActive("/event")}>
                        Events
                      </Link>
                      <ul>
                        {/* <li>
                          <Link onClick={ClickHandler} to="/event">
                            Upcoming Events
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link
                            onClick={ClickHandler}
                            to="/event-details/Modern-Marketing-Summit-Sydney"
                          >
                            Events Detail
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/register">
                            Account
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                    {/* <li className="dropdown">
                      <Link onClick={ClickHandler} to="/">
                        Blog
                      </Link>
                      <ul>
                        <li>
                          <Link onClick={ClickHandler} to="/blog">
                            Our Blog
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/blog-left-sidebar">
                            Blog left Sidebar
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/blog-classNameic">
                            Blog classNameic
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="/blog-single/International-Conference-On-Art-Business"
                          >
                            Blog Detail
                          </Link>
                        </li>
                        <li>
                          <Link onClick={ClickHandler} to="/not-found">
                            Not Found
                          </Link>
                        </li>
                      </ul>
                    </li> */}
                    <li className="dropdown">
                      <Link onClick={ClickHandler} to="/contact" style={isActive("/contact")}>
                        Contact
                      </Link>
                      <ul>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to="https://docs.google.com/forms/d/e/1FAIpQLSdXp0GEflJSHA2aJJ_oH_0K1lxq3uYucYOQrpz8A0nb1tEK5g/viewform?usp=header"
                          >
                            Reach Us
                          </Link>
                        </li>
                        {/* <li>
                          <Link onClick={ClickHandler} to="/contact-2">
                            Contact 02
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link onClick={ClickHandler} to="/contact-3">
                            Contact 03
                          </Link>
                        </li> */}
                      </ul>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            {/* Main Menu End*/}
            <div className="outer-box d-flex align-items-center flex-wrap">
              {/* Search Btn */}
              {/* <div
                className="search-box-btn search-box-outer"
                onClick={() => setSearchState(!searchActive)}
              >
                <span className="icon fa fa-search"></span>
              </div> */}

              {/* Nav Btn */}
              {/* <div
                className="nav-btn navSidebar-button"
                onClick={() => setCartState(!cartActive)}
              >
                <i className="fi flaticon-shopping-cart"></i>
              </div> */}

              <div className="appointmeny_button-box">
                <a
                  href="https://forms.fillout.com/t/3hPENLhFY1us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="theme-btn btn-style-one"
                >
                  <span className="btn-wrap">
                    <span className="text-one">Join The Tribe</span>
                    <span className="text-two">Join The Tribe</span>
                  </span>
                </a>
              </div>

              {/* Mobile Navigation Toggler */}
              <MobileMenu />
            </div>
          </div>
        </div>
      </div>
      {/*End Header Upper*/}
    </header>
  );
};

const mapStateToProps = (state) => {
  return {
    carts: state.cartList.cart,
  };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
